import React from "react";
import { DarkModeSwitch } from "react-toggle-dark-mode";

const Nav = (props) => {
  const { dark, setDark } = props.setDark;
  const { setSearch } = props;
  return (
    <div className="transition-all duration-1000 bg-slate-200 dark:bg-slate-700 py-1">
      <div className="container mx-auto flex justify-between items-center grow">
        <img src="media/images/logo.png" alt="meal-logo" width={60} />
        {/* Search */}
        <div>
          <input
            type="text"
            placeholder="Fish"
            className="py-2 px-2 md:px-9 rounded-md outline-none focus:ring-2 font-semibold dark:bg-slate-500 dark:text-white"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
        </div>
        <div>
          <DarkModeSwitch
            checked={dark}
            onChange={() => setDark(!dark)}
            size={40}
            className="mr-4 md:mr-0"
          />
        </div>
      </div>
    </div>
  );
};

export default Nav;
